var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-12 fill-height flex-column"},[_c('v-progress-circular',{staticClass:"ma-auto",attrs:{"color":"primary","size":"60","indeterminate":""}}),(_vm.message !== null)?_c('div',{staticClass:"pa-12 baColorSecondaryText--text loading-text"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }